import * as React from 'react';



export default class CloseCircle extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg viewBox="0 0 16 16" className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
        <g  stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" transform="translate(-865.000000, -735.000000)">
            <g id="information-msg" transform="translate(503.000000, 732.000000)">
                <g id="Group-6">
                    <g id="Group-4" transform="translate(44.000000, 3.000000)">
                        <g id="Close-icon" transform="translate(318.000000, 0.000000)">
                            <circle id="Oval-3" fill="#F2C688" opacity="0.200000003" cx="8" cy="8" r="8"></circle>
                            <g id="caption-cross-icon" transform="translate(4.000000, 4.000000)" stroke="#D3AA70" strokeLinecap="round">
                                <g id="Group-37">
                                    <g>
                                        <g id="Group-24" transform="translate(0.777778, 0.777778)">
                                            <path d="M0.294612795,0.294612795 L6.12764853,6.12764853" id="Line"></path>
                                            <path d="M0.294612795,0.294612795 L6.12764853,6.12764853" id="Line-Copy-2" transform="translate(3.211131, 3.211131) scale(1, -1) translate(-3.211131, -3.211131) "></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
